import { render, staticRenderFns } from "./clientProductApproval.vue?vue&type=template&id=afbb5b7a&scoped=true"
import script from "./clientProductApproval.vue?vue&type=script&lang=js"
export * from "./clientProductApproval.vue?vue&type=script&lang=js"
import style0 from "./clientProductApproval.vue?vue&type=style&index=0&id=afbb5b7a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbb5b7a",
  null
  
)

export default component.exports